import { createSelector } from '@ngrx/store';
import { TMachineMaintenanceState } from '../reducers';
import { TAttachmentState } from './attachment.model';

const getAttachmentState = (state: TMachineMaintenanceState) => state.attachmentInfo;

export const getAttachmentList = createSelector(getAttachmentState, (state: TAttachmentState) => {
  console.log('getAttachmentList selector ran');
  return state.attachmentListing;
});

export const getAttachmentListingPaginationOption = createSelector(
  getAttachmentState,
  (state: TAttachmentState) => state.attachmentListingPagination,
);

export const getAttachmentListingSearchStr = createSelector(
  getAttachmentState,
  (state: TAttachmentState) => state.attachmentListingSearchStr,
);

export const getAttachmentApprovalList = createSelector(
  getAttachmentState,
  (state: TAttachmentState) => state.attachmentApprovalsListing,
);
